export default {
  "i18n": {
    "chooseLang": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изменить язык:"])},
    "languages": {
      "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Английский"])},
      "ru": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Русский"])}
    },
    "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Язык Изменен"])}
  },
  "navBar": {
    "greeting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Здравствуйте, "])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выйти"])},
    "menuItems": {
      "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать Контакт"])},
      "import": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Импорт Контактов"])},
      "export": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Экспорт Контактов"])},
      "removeAll": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удалить Все Контакты"])}
    }
  },
  "export": {
    "titleCSV": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["№,Имя,Номер телефона,Электронная почта,Дата рождения\n"])},
    "emptyList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Список контактов пуст."])},
    "plainText": {
      "index": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакт №"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя: "])},
      "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер телефона: "])},
      "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Электронная почта: "])},
      "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата рождения: "])}
    }
  },
  "commonUI": {
    "copiedButton": {
      "toDoTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы скопировать в Буфер обмена"])},
      "doneTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скопировано в Буфер обмена"])}
    },
    "resultMessage": {
      "closeBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Закрыть"])}
    },
    "dialog": {
      "closeBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отменить"])}
    }
  },
  "dialogs": {
    "create": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавить Контакт"])},
      "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать"])}
    },
    "edit": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактировать Контакт"])},
      "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить"])}
    },
    "createAndEdit": {
      "inputs": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])},
        "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер телефона"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])},
        "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата рождения"])},
        "birthdayTip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["При ручном вводе неполная (дд.01.2000) или несуществующая (31 февраля) дата не будет добавлена"])}
      },
      "errors": {
        "nameRequired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя - обязательное поле."])},
        "longName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя должно быть не длиннее 40 символов."])},
        "phoneRequired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер телефона - обязательное поле."])},
        "invalidPhone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер телефона некорректен."])},
        "invalidMail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адрес электронной почты некорректен."])},
        "invalidDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата рождения некорректна"])},
        "earlyDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["К сожалению, политика сайта запрещает добавлять контакты людей из будущего"])},
        "lateDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не уверены, что вы сможете дозвониться до такого пожилого абонента. Попробуйте добавить кого-то помоложе"])}
      }
    },
    "import": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Импортировать Контакты"])},
      "inputTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вставьте данные JSON. Пример:"])},
      "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Свойства 'name' и 'phone' - обязательные"])},
      "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Импортровать"])},
      "errors": {
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Это обязательное поле."])},
        "invalid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Данные некорректны."])}
      }
    },
    "delete": {
      "one": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удалить Контакт"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы уверены, что хотите удалить Контакт? <br /> Это действие нельзя изменить."])},
        "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Да, удалить"])}
      },
      "all": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удалить Все Контакты"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы уверены, что хотите удалить Все Контакты? <br /> Это действие нельзя изменить."])},
        "btnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Да, удалить"])}
      }
    }
  },
  "auth": {
    "inputs": {
      "mail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адрес электронной почты"])},
      "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пароль"])},
      "errors": {
        "fieldRequired": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Это обязательное поле."])},
        "emailInvalid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адрес электронной почты некорректный."])}
      }
    },
    "buttons": {
      "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Войти"])},
      "signUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зарегистрироваться"])},
      "loginInstead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Уже есть аккаунт?"])},
      "signUpInstead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Еще не зарегистрированы?"])}
    },
    "info": {
      "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Загрузка..."])},
      "logoutMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["До свидания!"])},
      "autoLogoutMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ваша сессия истекла, авторизуйтесь заново!"])},
      "success": {
        "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Авторизация прошла успешно"])},
        "signUp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Регистрация прошла успешно"])}
      },
      "errors": {
        "errorMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка аутентификации! "])},
        "defaultMessage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пожалуйста, попробуйте позже."])},
        "login": {
          "EMAIL_NOT_FOUND": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пользователя с такой почтой не существует."])},
          "INVALID_PASSWORD": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы ввели неверный пароль!"])},
          "USER_DISABLED": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Аккаунт был отключен администратором!"])}
        },
        "signUp": {
          "EMAIL_EXISTS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Такой адрес электронной почты уже используется. Пожалуйста, попробуйте другой адрес"])},
          "TOO_MANY_ATTEMPTS_TRY_LATER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Запросы с вашего устройства отклонены из-за подозрительной активности. Попробуйте позже."])}
        }
      }
    }
  },
  "onboarding": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Почти закончили!"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Хотите, чтобы мы сразу добавили важные контакты (скорая, полиция)?"])},
    "addBtnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавить"])},
    "noAddBtnTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет, спасибо"])},
    "action": {
      "defaultContacts": {
        "police": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Полиция"])},
        "fireDepartment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пожарная служба"])},
        "ambulance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скорая помощь"])},
        "emergencyNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Единый номер экстренных служб"])}
      },
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка при добавлении важных контактов"])}
    }
  },
  "contacts": {
    "toolbar": {
      "inputLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Найти контакт"])}
    },
    "emptyList": {
      "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ничего не найдено"])},
      "noContacts": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы еще не добавили ни одного контакта"])},
        "createBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создать вручную"])},
        "btnsDevider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["или"])},
        "autoaddBtn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавить важные контакты (скорая, полиция)"])}
      }
    },
    "list": {
      "counterTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Всего контактов: "])},
      "item": {
        "info": {
          "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер"])},
          "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
          "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата рождения"])}
        },
        "buttons": {
          "call": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Позвонить"])},
          "write": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Написать"])}
        }
      }
    },
    "info": {
      "success": {
        "loaded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакты загружены"])},
        "import": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Импорт завершен. Все контакты (", _interpolate(_named("count")), " шт) были импортированы."])},
        "create": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакт добавлен"])},
        "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакт удален"])},
        "deleteAll": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Все Контакты удалены"])},
        "update": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакт обновлен"])}
      },
      "errors": {
        "loaded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка при загрузке контактов"])},
        "import": {
          "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка при импорте контактов"])},
          "duplicate": {
            "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ни один из контактов не был импортирован. Возможно, введенные контакты уже существуют или они записаны некорректно"])},
            "partly": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Импорт завершен. Часть контактов (", _interpolate(_named("issues")), " шт) не была импортирована. Возможно, введенные контакты уже существуют или они записаны некорректно"])}
          }
        },
        "create": {
          "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка при создании нового контакта"])},
          "exist": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Такой контакт уже существует"])}
        },
        "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка при удалении контакта"])},
        "deleteAll": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка при удалении контактов"])},
        "update": {
          "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка при обновлении контакта"])},
          "exist": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Такой контакт уже существует"])}
        }
      }
    }
  },
  "notFound": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Страница не найдена"])},
    "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Такой страницы еще не существует"])},
    "linkStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Возможно, Вы хотите посмотреть"])},
    "linkEnd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["список контактов?"])}
  }
}